<template>
  <div class="wrap">
    <!-- <div class="banner">
      <i-banner :list=imgList
                :height="4.21"></i-banner>
    </div> -->
    <div class="mask"
         @click="isShow= false"
         v-show="isShow"></div>

    <!-- <div class="search">
      <div class="search_inp">
        <div class="selContent"
             @click="searchModel">
          <ul v-if="egList.filter(v=>v.isSelect).length">
            <li v-for="(item,index) in egList"
                v-show="item.isSelect"
                :key="item.egId"><span>{{item.egName}}</span>
              <i @click.stop="delList(item,index)"
                 class="iconfont">&#xe713;</i></li>
          </ul>
          <b v-else>请选择</b>
        </div>
        <div class="searchIcon"
             @click="getData(type,1)">
          <i class="iconfont">&#xe601;</i>
        </div>

      </div>

      <div class="rel"
           v-show="isShow">
        <ul>
          <li @click="egListTab(item,index)"
              v-for="(item,index) in egList"
              :key="item.egId"
              :class="{'active':item.isSelect}"><span>{{item.egName}}</span></li>
        </ul>
      </div>

    </div> -->

    <div class="search">
      <div class="search_inp">
        <input type="text"
               placeholder="请输入直播名称/讲师姓名"
               v-model="title">
        <div class="searchIcon"
             @click="getData()">
          <i class="iconfont">&#xe601;</i>
        </div>

      </div>
      <div class="searchSelect">
        <i class="iconfont"
           @click="showList=!showList">&#xe64b;</i>
        <div class="searchList"
             v-show="showList">
          <ul>
            <li :class="item.isSelect?'activeTab':''"
                v-for="(item,index) in egList"
                @click="egListTab(item,index)"
                :key="item.egList">{{ item.egName }}
            </li>

          </ul>
          <div class="optBtn">
            <span @click="reset">重置</span>
            <span @click="getData(type,1)">筛选</span>

          </div>

        </div>

      </div>

    </div>
    <ul class='typeWrap'
        v-if="egList.filter(v=>v.isSelect).length">
      <div>分类：</div>
      <li v-for="(item,index) in egList"
          v-show="item.isSelect"
          :key="item.egId"><span>{{ item.egName }}</span>
        <i @click.stop="delList(item,index)"
           class="iconfont">&#xe713;</i></li>
    </ul>

    <div ref="container" class="container">
      <div class="noting"
           v-if="!list.lives_ing.filter(v=>v.lFl==1).length&&!list.lives_will.filter(v=>v.lFl==1).length&&!list.lives_ed.filter(v=>v.lFl==1).length">
        <img src="../../assets/images/nothing.png"
             alt=""
             srcset="">
      </div>
      <div class="type_title"
           v-if="list.lives_ing.filter(v=>v.lFl==1).length>0">
        <span class="live_type">直播中</span>
      </div>
      <div class="container_item"
           v-for="(item,index) in list.lives_ing"
           v-show="item.lFl==1"
           :key="'livesing'+index">

        <p class="item_title">
          <span class="title_name">
            <span>{{ item.group.egName }}</span>
          </span>
          <span class="title_time">{{ getTimes(item.lDt) }}</span>
        </p>
        <div class="con"
             @click="toDetails(item.lId)">
          <div style="position: relative;">
            <div v-if="checkUserMember">
                    <get-vip-img v-if="item.lIsvipfree==1"></get-vip-img>
                   </div>
          <img class="con_images"
               :src="item.lPicUrl"
               alt=""
               v-if="item.lPicUrl">
          <img class="con_images"
               src="../../assets/images/default.png"
               alt=""
               v-else>
          </div>
          <div class="con_right">
            <p class="con_title">{{ item.lTitle }}</p>
            <div>
              <p class="con_author">{{ item.lSpeaker }}</p>
              <p class='con_org'>{{ item.lOrg }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="type_title"
           v-if="list.lives_will.filter(v=>v.lFl==1).length>0">
        <span class="live_type">即将直播</span>
      </div>
      <div class="container_item"
           v-for="(item,index) in list.lives_will"
           v-show="item.lFl==1"
           :key="'liveswill'+index">
        <p class="item_title">
          <span class="title_name">
            <span>{{ item.group.egName }}</span>
          </span>
          <span class="title_time">{{ getTimes(item.lDt) }}</span>
        </p>
        <div class="con"
             @click="toDetails(item.lId)"
             style="border-bottom: 1px solid #e6e6e6;">
          <div style="position: relative;">
            <div v-if="checkUserMember">
                    <get-vip-img v-if="item.lIsvipfree==1"></get-vip-img>
                   </div>
          <img class="con_images"
               :src="item.lPicUrl"
               alt=""
               v-if="item.lPicUrl">
          <img class="con_images"
               src="../../assets/images/default.png"
               alt=""
               v-else>
          </div>
          <div class="con_right">
            <p class="con_title">{{ item.lTitle }}</p>
            <div>
              <p class="con_author">{{ item.lSpeaker }}</p>
              <p class='con_org'>{{ item.lOrg }}</p>
            </div>
          </div>
        </div>
        <div class="last">
          <span>预约人数：{{ item.lAppointNum }}人</span>
          <button class="footer_yybm"
                  @click="signUp(item.lIsAppoint,index,item.lId)"
                  :style="{background:item.lIsAppoint==1?'#999999':'linear-gradient(0deg,rgba(9,131,255,1) 0%,rgba(33,175,255,1) 100%)'}">
            {{ item.lIsAppoint == 1 ? '已预约' : '预约报名' }}
          </button>
        </div>

      </div>

      <div class="type_title"
           v-if="list.lives_ed.filter(v=>v.lFl==1).length>0">
        <span class="live_type">直播回顾</span>
      </div>
      <div class="container_item"
           v-for="(item,index) in list.lives_ed"
           v-show="item.lFl==1"
           :key="'livesed'+index">
        <p class="item_title">
          <span class="title_name"><span>{{ item.group.egName }}</span></span>
          <span class="title_time">{{ getTimes(item.lDt) }}</span>
        </p>
        <div class="con"
             @click="toDetails(item.lId)">
          <div style="position: relative;">
            <div v-if="checkUserMember">
                    <get-vip-img v-if="item.lIsvipfree==1"></get-vip-img>
                   </div>
          <img class="con_images"
               :src="item.lPicUrl"
               alt=""
               v-if="item.lPicUrl">
          <img class="con_images"
               src="../../assets/images/default.png"
               alt=""
               v-else>
          </div>
          <div class="con_right">
            <p class="con_title">{{ item.lTitle }}</p>
            <div class="con_div">
              <p class="con_author">{{ item.lSpeaker }}</p>
              <p class="con_author_red">{{ item.lViewCount }}人观看</p>
            </div>
            <p class="con_org">{{ item.lOrg }}</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import iBanner from '../container/banner'
import weui from 'weui.js'
import GetVipImg from '../getvipimg/getVipImg.vue';
import loginService from '../../plugin/extendFn/loginService';
import AppSetting from '../../AppSetting';


export default {
  data() {
    return {
      checkUserMember:true,
      isShow: false,
      imgList: [],
      list: null,
      title: '',
      uid: '',
      ra_wxUser: null,
      showList: false,
      egList: [],
      type: '',
      selectList: [],
    }
  },
  props: {},
  created() {
    this.$waiting.show(3);
  },
  watch: {
    title: function (value) {
      if (value == '') {
        this.getData()
      }
    }
  },
  methods: {
    tabList() {

    },
    searchModel() {
      this.isShow = true

    },
    delList(res, index) {
      let item = res;
      item.isSelect = false
      this.$set(this.egList, index, item)
      setTimeout(() => {
        this.getData()

      }, 500)
    },
    reset() {

      this.egList.map((item, index) => {
        item.isSelect = false
        this.$set(this.egList, index, item)

      })

    },
    // searchModel () {
    //   this.showList = false

    // },
    egListTab(res, index) {
      let item = res;
      item.isSelect = !item.isSelect
      this.$set(this.egList, index, item)
      // this.selectList = this.egList.filter(v => v.isSelect)
    },
    getEngList() {
      this.$postHttp(AppSetting.baseUrl + '/common/entgroup/info', {}).then((res) => {
        if (res.data.code == 0) {
          let data = res.data.list;
          this.egList = data
          this.egList.map((item) => {
            item.isSelect = false
          })
        }

      })
    },
    getData() {
      let eglist = this.egList.filter(v => v.isSelect)
      console.log(eglist)
      let eg_ids = []
      if (eglist.length) {
        eglist.map(item => {
          eg_ids.push(item.egId)
        })

      }
      var param = {
        uid: this.ra_wxUser ? (this.ra_wxUser.uId ? this.ra_wxUser.uId : '') : '',
        keyword: this.title,
        eg_ids: eg_ids

      }
      this.$postHttp(AppSetting.baseUrl + '/live/student/list', param).then((res) => {
        if (res.data.code == 0) {
          this.$waiting.hide();
          let data = res.data.value;
          this.list = data;

          this.imgList = data.pictures;
          this.showList = false
          this.isShow = false


        }
      })
    },
    getTimes(value) {
      return new Date(value).Format("yyyy.MM.dd hh:mm");
    },
    toDetails(id) {
      this.$router.push({
        name: "Details",
        query: {type: "live", liveId: id}
      })
    },
    async signUp(status, index, lid) {
      if (await loginService.isNotLogin()) {
        this.login();
      } else {
        if (status == 0) {
          this.$postHttp(AppSetting.baseUrl + '/live/appointment', {
            uid: this.ra_wxUser ? (this.ra_wxUser.uId ? this.ra_wxUser.uId : '') : '',
            lid: lid
          }).then((res) => {
            if (res.data.code == 0) {

              this.$set(this.list.lives_will[index], 'lIsAppoint', 1);
              //参数：要改的对象、要改的key 、要改值
              this.$toast.success('预约成功')
            } else {
              this.topTips('预约失败')
            }

          })
        } else {
          weui.dialog({
            content: '确定要取消预约吗？',
            className: 'yors',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: (res) => {
                // alert('取消')
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {

                this.$postHttp(AppSetting.baseUrl + '/live/appointment/cancel', {
                  uid: this.ra_wxUser ? (this.ra_wxUser.uId ? this.ra_wxUser.uId : '') : '',
                  lid: lid
                }).then((res) => {
                  if (res.data.code == 0) {
                    this.$set(this.list.lives_will[index], 'lIsAppoint', 0);
                    this.$toast.success('取消成功');
                  } else {
                    this.topTips('取消预约失败')
                  }
                })
              }
            }]
          });
        }
      }

    },

    login () {
      loginService.login(this.$router)
      .then(loginUser=>{
        this.ra_wxUser=loginUser
      })
    },
    containerScroll(e) {
      let container = this.$refs['container'];

      //文档内容实际高度（包括超出视窗的溢出部分）
      let scrollHeight = container.scrollHeight;
      //滚动条滚动距离
      let scrollTop = container.scrollTop;
      //窗口可视范围高度
      let clientHeight = container.clientHeight;
      localStorage.setItem('_scrollTop', scrollTop);

      /*if (clientHeight + scrollTop >= scrollHeight - 80) {
        if (this.reachBottom) {
          console.log('onReachBottom')
          this.reachBottom = false;
          this.onReachBottom && this.onReachBottom();
        }
      } else {
        this.reachBottom || (this.reachBottom = true)
      }*/
    },
  },
  computed: {},
  components: {
    iBanner,GetVipImg
  },
  async mounted() {
    this.ra_wxUser= await loginService.getLoginUser();

    document.title = '直播';
    //document.body.scrollTop = document.documentElement.scrollTop = 0;
    let that = this;

    setTimeout(() => {
      let container = that.$refs['container'];
      container.addEventListener('scroll', that.containerScroll, false);
    }, 2000)

  },
  beforeDestroy() {
    document.title = '';
    let container = this.$refs['container'];
    container.removeEventListener('scroll', this.containerScroll, false);
  },
  activated() {
    if (this.$route.meta.keepAliveChange) {
      this.title = '';
      this.egList = [];

      this.list = {};
      localStorage.setItem('_scrollTop', 0);
      this.getEngList()
      this.getData();
      console.log('----------------keepAliveChange:true')
    } else {
      console.log('----------------keepAliveChange:false')
      let scrollTop = localStorage.getItem('_scrollTop');
      let container = this.$refs['container'];
      container.scrollTop = scrollTop ? scrollTop : 0;
    }
  }
}
</script>
<style scoped lang="scss">
.wrap {
  background: #f4f5f4;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.banner {
  width: 7.5rem;
}

.search {
  width: 100%;
  background: #f7f7f7;
  display: flex;
  align-items: center;
  padding: 0.2rem 0.3rem 0.1rem;
  box-sizing: border-box;
  flex-grow: 0;
  flex-shrink: 0;

  // position: fixed;
  // top: 0;
  // left: 0;
  // z-index: 1000;
  .search_inp {
    width: 4.8rem;
    height: 0.7rem;
    border: 1px solid #dbdbdb;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background: #ffffff;
    display: flex;
    align-items: center;

    width: 100%;

    input {
      // width:4.21rem;

      display: inline-block;
      width: 100%;
      border: none;
      padding-left: 0.21rem;
      box-sizing: border-box;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      outline: none;
      font-size: 0.28rem;
      height: 0.7rem;
    }

    input::placeholder {
      font-size: 0.28rem;
    }

    .searchIcon {
      width: 1.2rem;
      height: 0.7rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-left: 1px solid #dbdbdb;
      color: #1b94f5;

      i {
        font-size: 0.34rem;
      }
    }
  }

  .searchSelect {
    width: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .iconfont {
      font-size: 0.5rem;
      margin-left: 0.2rem;
      color: #1b94f5;
    }

    .searchList {
      position: absolute;
      width: 3.6rem;
      height: 5rem;
      font-size: 0.3rem;
      top: 0.8rem;
      right: -0.3rem;
      background: #fff;
      z-index: 1000;
      text-align: center;
      box-shadow: #1b94f5;

      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.6);
      border-radius: 3px;
      overflow: hidden;
      padding: 0.2rem 0.2rem 0 0.2rem;

      ul {
        height: 4.18rem;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow-y: scroll;
      }

      li {
        background: #ededed;

        padding: 0px 0.2rem;
        border-radius: 1rem;
        margin-right: 0.15rem;
        margin-top: 0.25rem;
        padding: 0px 10px;
        font-size: 0.22rem;
      }

      .activeTab {
        background: #087ff8;
        color: #fff;
      }
    }

    .optBtn {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      width: 100%;

      span {
        flex-grow: 1;
        height: 0.8rem;

        &:nth-child(1) {
          background: #dbdbdb;
          line-height: 0.8rem;
        }

        &:nth-child(2) {
          color: #fff;
          background: #087ff8;
          line-height: 0.8rem;
        }
      }
    }
  }

  .search_type {
    width: 1.8rem;
    display: flex;
    font-size: 0.28rem;
    height: 0.7rem;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    margin-left: 0.29rem;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    z-index: 11;

    span {
      /*display: inline-block;*/
      color: #1b94f5;
      width: 1.2rem;
      height: 0.7rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }

    div {
      width: 0.6rem;
      height: 0.7rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-left: 1px solid #dbdbdb;

      img {
        width: 0.48rem;
        height: 0.48rem;
      }
    }
  }
}

.container {
  // margin-bottom: 0.98rem;
  flex-grow: 1;
  overflow: auto;

  .noting {
    width: 100vw;
    flex-grow: 1;

    img {
      width: 4rem;
      margin: 0 auto;
      height: auto;
      display: block;
      margin-top: 2.5rem;
    }
  }

  .container_item {
    background: #ffffff;
    margin-bottom: 0.21rem;
    padding-left: 0.3rem;
    box-sizing: border-box;
    border-bottom: 1px solid #e6e6e6;

    .item_title {
      padding-right: 0.29rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      padding-top: 0.16rem;
      padding-bottom: 0.21rem;

      .title_name {
        font-size: 0.26rem;
        color: #666666;
        width: 4.2rem;
        overflow: hidden;

        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .title_time {
        font-size: 0.24rem;
        color: #999999;
      }
    }

    .con {
      /*border-bottom: 1px solid #E6E6E6;*/
      box-sizing: border-box;
      padding-bottom: 0.16rem;
      height: 1.77rem;
      display: flex;
      align-items: flex-start;
      flex-shrink: 0;

      .con_right {
        /*height: 1.62rem;*/
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .con_images {
        width: 2.84rem;
        height: 1.6rem;
        margin-right: 0.22rem;
      }

      .con_title {
        width: 3.83rem;
        font-size: 0.28rem;
        color: #333333;
        line-height: 0.42rem;
        display: -webkit-box;
        -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
        -webkit-line-clamp: 2; /*限制文本行数*/
        font-weight: bold;
        /*white-space: nowrap;      !*超出的空白区域不换行*!*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis; /*文本超出显示省略号*/

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /* autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        -webkit-line-clamp: 2;
      }
    }

    .con_author {
      /*margin-top: 0.68rem;*/
      color: #666;
      font-size: 0.24rem;
    }

    .con_author_red {
      /*margin-top: 0.68rem;*/
      color: red;
      font-size: 0.24rem;
    }

    .con_org {
      font-size: 0.26rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 3.83rem;
    }
  }

  .type_title {
    padding-left: 0.33rem;
    box-sizing: border-box;
    border-bottom: 1px solid #e6e6e6;
    margin-top: 0rem;
  }

  .last {
    span:nth-of-type(1) {
      font-size: 0.26rem;
    }
  }

  .last,
  .type_title {
    display: flex;
    height: 0.8rem;
    justify-content: space-between;
    padding-right: 0.29rem;
    align-items: center;
    background: #ffffff;

    button {
      width: 1.4rem;
      height: 0.5rem;
      background: linear-gradient(
              0deg,
              rgba(9, 131, 255, 1) 0%,
              rgba(33, 175, 255, 1) 100%
      );
      border-radius: 25px;
      font-size: 0.26rem;
      color: #ffffff;
      border: none;
      outline: none;
    }
  }

  .footer_type {
    font-size: 0.26rem;
    color: #ffb400;
  }

  .textColor {
    color: #2bcf4a;
  }

  .live_type {
    font-size: 0.34rem;
    font-weight: bold;
    color: #007eff;
  }
}

.mask {
  position: fixed;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  font-size: 0.24rem;
  background: rgba(0, 0, 0, 0.5);
}

.rel {
  font-size: 0.28rem;

  ul {
    width: 6.9rem;
    /*height: 3.57rem;*/
    background: #ffffff;
    // top: 1.21rem;
    // position: absolute;
    // left: 0.32rem;
    margin-top: 0.1rem;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0.1rem 0.3rem;
    box-sizing: border-box;
    z-index: 11;

    li {
      height: 0.6rem;
      display: flex;
      align-items: center;
      /*vertical-align: center;*/
    }

    .active {
      color: rgba(0, 126, 255, 1);
    }
  }
}

.typeWrap {
  font-size: 0.2rem;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  flex-wrap: wrap;
  padding: 0 0.3rem 0.1rem;

  li {
    border: 1px solid #007eff;
    border-radius: 1rem;
    margin-right: 0.2rem;
    padding: 1px 5px;
    background: #fff;
    color: #007eff;
    margin-bottom: 5px;

    .iconfont {
      font-size: 0.18rem;
    }
  }
}

.con_div {
  display: flex;
  flex-wrap: nowrap;
  //width:200px;
  justify-content: space-between;

}
</style>



// WEBPACK FOOTER //
// src/components/live/testlivelist.vue